import { ApIcon } from '@alixpartners/ui-components';
import React from 'react';
import { Container, NoDataText, Left } from './FileRow.styles';

export const FileRowEmpty = () => (
  <Container>
    <Left>
      <ApIcon iconName="cloud_upload" />
      <NoDataText>No data uploaded</NoDataText>
    </Left>
  </Container>
);
